import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import { hasBackofficeRole } from "utils/authRoles";

const ProtectedRoute = () => {
  const auth = useAuth();
  const { isAuthenticated, isLoading } = auth;

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (!hasBackofficeRole(auth.user?.profile)) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
